import { VStack } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { HistorySidebar } from 'Features/History/HistorySidebar';
import {
  FETCH_BATCH_SIZE,
  TARGET_INITIAL_COUNT,
  TARGET_LOAD_MORE_COUNT,
  useEsrsAuditLogs,
} from 'Features/History/History.hooks';
import { useEsrsAssessmentQuery } from 'models';
import { useParams } from 'react-router-dom';
import { Typography } from 'Tokens';

export const MetricUpdates = ({ answerId }: { answerId?: string }) => {
  const { esrsAssessmentId } = useParams();

  const [auditLogsPagination, setAuditLogsPagination] = useState({
    limit: 0,
    offset: 0,
  });
  const [targetCount, setTargetCount] = useState(TARGET_INITIAL_COUNT);

  const { data } = useEsrsAssessmentQuery({
    variables: { esrsAssessmentId },
    skip: !esrsAssessmentId,
  });

  const esrsAssessment = useMemo(() => data?.esrsAssessment, [data]);
  const loadMore = () => {
    setAuditLogsPagination((prev) => ({
      limit: FETCH_BATCH_SIZE,
      offset: prev.offset + prev.limit,
    }));
  };

  const incrementTargetCount = () => {
    setTargetCount((prev) => prev + TARGET_LOAD_MORE_COUNT);
  };

  useEffect(() => {
    setTargetCount(TARGET_INITIAL_COUNT);
    setAuditLogsPagination({ limit: TARGET_INITIAL_COUNT, offset: 0 });
  }, []);

  const { auditLogs, hasMoreData, refetchLoading, loading } = useEsrsAuditLogs({
    esrsAssessment,
    answerId,
    isSidebar: true,
    ...auditLogsPagination,
  });

  return (
    <VStack alignItems="start" width="100%" p="24px 20px" spacing="12px">
      {!auditLogs.length && (
        <Typography variant="body" color="text.hint" alignSelf="center">
          There are no updates yet
        </Typography>
      )}
      <HistorySidebar
        auditLogs={auditLogs}
        loading={loading}
        searchValue={''}
        noPadding
        loadMore={loadMore}
        hasMoreData={hasMoreData}
        refetchLoading={refetchLoading}
        targetCount={targetCount}
        incrementTargetCount={incrementTargetCount}
      />
    </VStack>
  );
};
